/**
 * Get todos os cookies
 *
 * @return {array} - Retorna um array com todos os cookie no formato de um objeto [{ name: value }]
 */
function getAllCookie() {
  const cookies = document.cookie ? document.cookie.split('; ') : [];

  return cookies.map((cookie) => {
    const parts = cookie.split('=');
    return { [parts[0]]: parts[1] };
  });
}

/**
 * Seta um cookie vaseado na infos passadas
 *
 * @param {object} cookie
 * @param {string} cookie.name - Nome do cookie a ser criado
 * @param {string} cookie.value - Valor do cookie
 * @param {object} attributes
 * @param {object} attributes.path - Caminho onde o cookie vai ficar
 * @param {object} attributes.expires - O tempo que o cookie deve ficar
 */
function setCookie(cookie, attributes) {
  const date = new Date();
  const attr = attributes || {};

  if (attributes === undefined) {
    attr.expires = 24;
    attr.path = '/';
  }
  const { expires, path } = attr;

  date.setTime(date.getTime() + (expires * 24 * 60 * 60 * 1000));
  document.cookie = `${cookie.name}=${cookie.value}; expires=${date.toGMTString()}; path=${path}`;
}

/**
 * Pega um cookie
 *
 * @param {string} key - O nome do cookie
 * @return {string} - Retorna o value do cookie
 */
function getCookie(key) {
  const cookies = getAllCookie();
  const res = cookies.filter(cookie => (Object.getOwnPropertyNames(cookie)[0] === key));
  return res.length > 0 ? res[0][key] : null;
}

/**
 * Deleta um cookie
 *
 * @param {string} key - Nome do cookie a ser deletado
 */
function deleteCookie(key) {
  document.cookie = `${key}= ; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

/**
 * Verifica se um cookie existe
 *
 * @param {string} key - Nome do cookie a ser virificado
 */
function hasCookie(key) {
  return !!getCookie(key);
}

export default {
  getAll: getAllCookie,
  get: getCookie,
  set: setCookie,
  has: hasCookie,
  delete: deleteCookie,
};
